// mantine
import { ActionIcon, Badge, Menu, Table } from '@mantine/core';
// icons
import { Edit, Link2Off, Ellipsis } from 'lucide-react';
// types
import { TAccountLink } from '@newo/api/gateway';
// utils
import { ROLE_COLORS } from '@/pages/Profile/components/Members/Members.data';

interface MemberRowProps {
    member: TAccountLink;
    onEdit: (member: TAccountLink) => void;
    onDelete: (member: TAccountLink) => void;
    isAdmin?: boolean;
}

const MemberRow = ({ member, onEdit, onDelete, isAdmin }: MemberRowProps) => {
    return (
        <Table.Tr>
            <Table.Td>{member.email}</Table.Td>
            {isAdmin ? <Table.Td>{member.tenant}</Table.Td> : undefined}
            <Table.Td className="text-right">
                <Badge
                    className="capitalize"
                    color={ROLE_COLORS[member.role]}
                    size="md"
                    variant="light"
                >
                    {member.role.split('_').join(' ')}
                </Badge>
            </Table.Td>
            <Table.Td className="text-right">
                <Menu>
                    <Menu.Target>
                        <ActionIcon variant="transparent">
                            <Ellipsis />
                        </ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Item
                            leftSection={<Edit />}
                            onClick={() => {
                                onEdit(member);
                            }}
                        >
                            Edit
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item
                            className="text-red-5"
                            leftSection={<Link2Off />}
                            onClick={() => {
                                onDelete(member);
                            }}
                        >
                            Unlink
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
            </Table.Td>
        </Table.Tr>
    );
};

export default MemberRow;
